import { RepFieldAudit } from "@repo/models";
import { FC } from "react";

import style from "./style.module.scss";

interface ScoreProps {
	id: string;
	repFieldAudit?: RepFieldAudit;
}

export const Score: FC<ScoreProps> = (props) => {
	const score = !props.repFieldAudit.score ? 0 : props.repFieldAudit.score;

	const scoreAmount = props.repFieldAudit.scoreAmount ?? 0;
	const scoreTotal = props.repFieldAudit.scoreTotal ?? 0;

	return (
		<div className={style.root}>
			<span className={style.title}>Score</span>
			<span>
				{(score * 100).toFixed(2)}% ({scoreAmount}/{scoreTotal})
			</span>
		</div>
	);
};
